import type { IDocumentAssemblerTemplateVersionSummary } from '@commenda/api';
import { Badge, Dropdown, Icons } from '@commenda/kakashi';

interface IDocumentAssemblerVersionPickerBadgeProps {
  version: number;
  isLive: boolean;
  /** Newest first. One entry is a statement; several make the badge a picker. */
  publishedVersions: IDocumentAssemblerTemplateVersionSummary[];
  activeVersionId: string | null;
  onVersionSelect: (versionId: string) => void;
}

/** Which version is on screen, and whether it is the one documents are drafted from. */
export const DocumentAssemblerVersionPickerBadge = ({
  version,
  isLive,
  publishedVersions,
  activeVersionId,
  onVersionSelect,
}: IDocumentAssemblerVersionPickerBadgeProps) => {
  const badge = (
    <Badge variant={isLive ? 'success' : 'warning'} size="sm" hasDot={isLive}>
      {`Version ${version}${isLive ? ' · live' : ' · not live'}`}
    </Badge>
  );

  if (publishedVersions.length < 2) return badge;

  return (
    <Dropdown
      align="start"
      menu={{
        groups: [
          {
            items: publishedVersions.map((published) => ({
              label: `Version ${published.version}${published.id === activeVersionId ? ' · live' : ''}`,
              onClick: () => onVersionSelect(published.id),
            })),
          },
        ],
      }}
    >
      <button
        type="button"
        aria-label={`Version ${version}, choose another`}
        className="flex items-center gap-xs rounded-xs focus-visible:outline focus-visible:outline-1 focus-visible:outline-fg-brand"
      >
        {badge}
        <Icons.ChevronDown className="size-3 text-fg-tertiary" />
      </button>
    </Dropdown>
  );
};
